import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllModules } from 'ag-grid-enterprise';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import 'ag-grid-enterprise';
import { Link } from 'react-router-dom';
import { LicenseManager } from 'ag-grid-enterprise';
import { Button, Icon, Input,  Form as FormUi, Grid, Segment, Dropdown } from 'semantic-ui-react';
import { Formik , Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { DateData } from '../formikInput/date';

import CustomNoRowsOverlay from './customNoRowsOverlay';
import TitleBar from '../titleBar/titleBar';
import { last } from 'lodash';
import ImportModal from '../titleBar/importModal';
import { PROMPTS,DATE_FORMATS, REQUIRED_MESSAGES } from '../../config/const'
import {BUTTONS, FILTER_TITLES, PLACE_HOLDERS} from './agGridTableConstants'
import PurchaseOrderVendorDropdown from '../dropdowns/purchaseOrderVendorDropdown';
import VendorVehicleDropdown from '../dropdowns/vendorVehicleDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import { MyNormalInput } from '../myInputs';

LicenseManager.setLicenseKey('Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545')

class AgGridTable extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading:false,
            showFilterDiv:false,
            ImportModalState: false, 
            statusSelected:[],
            modules: AllModules,
            vehicleData:[],
            searchValue:'',
            defaultColDef: {
                flex: 1,
                minWidth: 100,
                enableValue: true,
                enableRowGroup: true,
                enablePivot: true,
                resizable: true,
            },
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel'
                    },
                    {
                        id: 'filters',
                        labelDefault: 'Filters',
                        labelKey: 'filters',
                        iconKey: 'filters',
                        toolPanel: 'agFiltersToolPanel'
                    },
                ],
                defaultToolPanel: '',
            },
            isLoading: true,
            rowData: [],
            frameworkComponents: {
                actionRenderer: props.actionButton,
                customNoRowsOverlay: CustomNoRowsOverlay,
                ...props.extraComponents
            },
            noRowsOverlayComponent: 'customNoRowsOverlay',
            noRowsOverlayComponentParams: {
                noRowsMessageFunc: function () {
                    return PROMPTS.NO_RECORDS_FOUND;
                },
            },
        };
    };

    handleSearch = (e) => {
        if(this.props.hasOwnProperty('customSearch')){
          this.props.customSearch(e.target.value)
        } else {
          this.setState({ searchValue: e.target.value })
        }
      }
  
    getParams() {
        //console.log("{Orpopripri", this.props.columnKeys)
        return {
            allColumns: false,
            fileName: this.props.titleBarTitle,
            columnKeys: this.props.columnKeys
        };
    };

    handleImportClose = () => {
        this.setState({ ImportModalState: false });
        window.location.reload();
    };

    handleFilter = () => {
        this.setState({showFilterDiv:!this.state.showFilterDiv})
    }

    handleStatusChange = (e, data) => {
        this.setState({...this.state.statusSelected ,statusSelected:data.value});
    }

    getVehicleData = childData => {
        this.setState({vehicleData:childData})
    }
    
    importDataGrid = () => {
        //console.log("import the data grid"); //test why is it here
    };

    filterChanged = (e) => {
        if (this.gridApi.getDisplayedRowCount() === 0) {
            this.gridApi.showNoRowsOverlay();  
        } else {
            this.gridApi.hideOverlay();
        };
    };

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.setState({
            isLoading: this.props.isLoading,
        });

        this.gridColumnApi = params.columnApi;

        //AutoSize Columns OnGridReady
        var allColumnIds = [];

        this.gridColumnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.colId);
        });

        this.gridColumnApi.autoSizeColumns(allColumnIds);
    };

    exportDataGrid = async () => {
        this.setState({ loading: true })
        if (this.props.bills == true) {
            let xlsx = require('json-as-xlsx')
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo,
                })

            Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/getBills`, data, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                this.setState({ loading: false })
                if (response?.data?.data?.length > 0) {
                    let excelData = [
                        {
                            sheet: "bills",
                            columns: [
                                { label: 'Partner Bill No', value: 'billNo' },
                                { label: 'Partner Bill Date', value: 'billDate' },
                                { label: 'Bill Ref No', value: 'billReferenceNo' },
                                { label: 'Integrated Ref No', value: 'integratedReferenceNumber' },
                                { label: 'Bill Receipt Date', value: 'billReceiptDate' },
                                { label: 'Partner Name', value: 'vendorName' },
                                { label: 'Bill Amount', value: 'billAmount' },
                                { label: 'Pending Amount', value: 'pendingAmount' },
                                { label: 'Expected Payment Date', value: 'expectedPaymentDate' },
                                { label: 'Penalities', value: 'penalties' },
                                { label: 'Remarks', value: 'remarks' },
                                { label: 'GL Code', value: 'GLCode' },
                                { label: 'Branch Name', value: 'branchName' },
                                { label: 'Status', value: 'approvalStatus' },
                                { label: 'Created On', value: 'createdOn' },
                                { label: 'Created By', value: 'createdBy' },
                                { label: 'Modified On', value: 'modifiedOn' },
                                { label: 'Modified By', value: 'modifiedBy' },
                            ],
                            content: response.data.data.map(({
                             billNo, billDate, branchName, remarks, GLCode, billReferenceNo, integratedReferenceNumber,integratedReferenceNumberErrorContent, billReceiptDate, vendorName, billAmount, pendingAmount, expectedPaymentDate, penalties, approvalStatus, createdOn, createdBy, modifiedOn, modifiedBy
                            }) => {
                                if(integratedReferenceNumber == 'Error'){
                                return ({
                                     billNo, billDate, branchName, remarks, GLCode, billReferenceNo ,integratedReferenceNumber:integratedReferenceNumberErrorContent , billReceiptDate, vendorName, billAmount, pendingAmount, expectedPaymentDate, penalties, approvalStatus, createdOn, createdBy, modifiedOn, modifiedBy
                                })}
                                else {
                                    return ({
                                        billNo, billDate, branchName, remarks, GLCode, billReferenceNo ,integratedReferenceNumber , billReceiptDate, vendorName, billAmount, pendingAmount, expectedPaymentDate, penalties, approvalStatus, createdOn, createdBy, modifiedOn, modifiedBy
   
                                   })
                                }
                            })
                        },
                    ]
                    let settings = {
                        fileName: "Billing",
                        writeMode: "writeFile",
                    }
                    if (excelData.length > 0) {
                        xlsx(excelData, settings)
                    }
                }
            }))
                .catch(error => console.log(error)).then()
        } else if (this.props.PO == true) {
            this.setState({ loading: true })

            let xlsx = require('json-as-xlsx')
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo,
                })

            Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/purchaseorder/getPurchaseOrders`, data, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                this.setState({ loading: false })
                if (response?.data?.data?.length > 0) {
                    let excelData = [
                        {
                            sheet: "Purchase Order",
                            columns: [
                                { label: 'PO No', value: 'poNumber' },
                                { label: 'Order No', value: 'orderNo' },
                                { label: 'PO Date', value: 'poDate' },
                                { label: 'Ref No', value: 'poReferenceNo' },
                                { label: 'Partner Name', value: 'vendorName' },
                                { label: 'Amount', value: 'poAmount' },
                                { label: 'Branch Name', value: 'branchName' },
                                { label: 'Remarks', value: 'remarks' },
                                { label: 'Vehicle NO', value: 'vehicleNo' },
                                { label: 'Created On', value: 'createdOn' },
                                { label: 'Created By', value: 'createdBy' },
                                { label: 'Modified On', value: 'updatedOn' },
                                { label: 'Modified By', value: 'updatedByName' },
                            ],
                            content: response.data.data.map(({
                                poNumber, orderNo, poDate, poReferenceNo, remarks, branchName, poAmount, vehicleNo, vendorName, createdOn, createdBy, updatedByName, updatedOn
                            }) => {
                                return ({
                                    poNumber, orderNo, poDate, poReferenceNo, remarks, branchName, poAmount, vehicleNo, vendorName, createdOn, createdBy, updatedByName, updatedOn

                                })
                            })
                        },
                    ]
                    let settings = {
                        fileName: "Purchase Order",
                        writeMode: "writeFile",
                    }
                    if (excelData.length > 0) {
                        xlsx(excelData, settings)
                    }
                }
            }))
                .catch(error => console.log(error)).then()
        }else{
            let keys = [];
            await this.props.columnDefs.forEach((element) => {
            element.field !== "edit" && keys.push(element.headerName);
            });
            let param = {
            fileName: this.props.titleBarTitle,
            };
            this.gridApi.exportDataAsExcel(param);
            setTimeout(()=>{
                this.setState({ loading: false })
            },5000)
        }
    };

    currentDate = new Date()

    render() {
        console.log(this.state.statusSelected,'this.state.statusSelected')

        const month = this.currentDate.getMonth();
        const year = this.currentDate.getFullYear();

        const firstDay = new Date(year, month, 1);
        
        const initialValues = {
            startDate: firstDay || '',
            endDate: this.currentDate || '' ,
            billStatus: '',
            vendorName: '',
            vehicleNo: '',
            vehicleId: '',
            branch: '',
            branchId: '',
            lrNumbers:''
        }

        const validateSchema = yup.object().shape({
            startDate: yup.string().nullable(),
            endDate: yup.string().nullable().when(['startDate'], {
                is: (startDate, ) => {
                    if (startDate != (null || undefined)) {
                        return true // validate and go to then function
                    }
                    else return false // for all other cases studentName is not required
                },
                then: (schema) =>
                    schema
                    .required(REQUIRED_MESSAGES.END_DATE_REQUIRED)
            })
        })

        const onSubmit = (values) => {
            this.setState({isFilter:true})
            let branchId = ''
            if(values.branch != ''){
                branchId = values.branchId

            }else{ 
                branchId = ''
            }

            let vehicleId = ''
            if(values.vehicleNo != ''){
                vehicleId = values.vehicleId

            }else{ 
                vehicleId = ''
            }
            this.props.getFilterDates(null,values.startDate, values.endDate, this.state.statusSelected, values.vendorName, values.vehicleNo, vehicleId, branchId,values.lrNumbers)
        }

        return (
            <>
                <TitleBar approvals={this.props.approvalSection} title={this.props.titleBarTitle} hiddenNew={this.props.hiddenNew} LinkName={this.props.link} newModalFunction={this.props.newModalFunction} >

                    {this.props.approvalCountSection ?

                        <div className="mr-4">
                            <Button.Group>
                                <Button size='tiny' type='button' className="w3-tiny w3-border" basic color="light-grey" icon>{BUTTONS.pending || "Pending"} {this.props.approvalData.pending}</Button>
                                <Button size='tiny' type='button' className="w3-tiny   " basic color="yellow" icon>{BUTTONS.approved || "Approved"} {this.props.approvalData.approved}</Button>
                                <Button size='tiny' type='button' className="w3-tiny" basic color="red" icon>{BUTTONS.rejected || "Rejected"} {this.props.approvalData.rejected}</Button>
                                <Button size='tiny' type='button' className="w3-tiny " basic color="blue" icon>{BUTTONS.partial || "Partial"} {this.props.approvalData.partialPayment}</Button>
                                <Button size='tiny' type='button' className="w3-tiny" basic color="green" icon>{BUTTONS.completed || "Completed"} {this.props.approvalData.completed}</Button>
                            </Button.Group>
                        </div>

                        :

                        ""

                    }
                    {this.props.master &&
                        <>
                            <div className="input-group-prepend">
                                <span className="input-group-text w3-white" style={{ borderRadius: '20px 0px 0px 20px' }}><i className="fa fa-search"></i> </span>
                            </div>
                            <input type="text" onChange={this.handleSearch} className="w3-small form-control" style={{ borderRadius: '0px 20px 20px 0px' }} placeholder="Search" />
                        </>
                    }
                    {this.props.PO == true && <Input size='mini' icon={{ name: 'search', circular: true }} onKeyUp={this.props.handleSearch} className="mr-4 ml-4 searchInput" placeholder={PLACE_HOLDERS.POsearch || "PO No, PO Ref No, Amount"} />}
                    {this.props.bills == true && <Input size='mini' icon={{ name: 'search', circular: true }} onKeyUp={this.props.handleSearch} className="mr-4 ml-4 searchInput" placeholder={PLACE_HOLDERS.BillSearch || "Bill No, Bill Ref No, Amount"} />}
                    <Button hidden={this.props.exportHidden} disabled={this.props.payments || this.props.debitNote} loading={this.state.loading} size='tiny' onClick={this.exportDataGrid} className="ml-4" basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/export.svg" /></i> {BUTTONS.export || "Export"}</Button>
                    {this.props.showImport && <Button  size='tiny' onClick={() => { this.setState({ ImportModalState: true }); }} basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/import.svg" /></i> {BUTTONS.import || "Import"}</Button>}
                    <Button as={Link} to={this.props.importLink && this.props.importLink} hidden={this.props.hiddenImportPopupBtn} size="tiny" basic color="facebook" icon><i className="icon"><img alt="import" src={"assets/svg/import.svg"} /></i>{BUTTONS.import || "Import"}</Button>
                    <Button
                        size="mini"
                        disabled={this.props.disableFilter}
                        onClick={this.handleFilter}
                        basic
                        color="facebook"
                        icon
                    >
                        <Icon name="filter" size="small" />
                        {BUTTONS.Filter}
                    </Button>
                </TitleBar>
                {this.state.showFilterDiv == true ?
                    <>
                        <div className="ui fluid container m-2">
                            <Segment>
                                <FormUi.Group inline>
                                    <FormUi.Field>
                                        <Formik
                                            initialValues={initialValues}
                                            validationSchema={validateSchema}
                                            onSubmit={onSubmit}
                                        >
                                            {({ touched, isSubmitting, errors, values, handleSubmit, form }) => (
                                                <>
                                                    <Grid
                                                        columns={4}
                                                        stackable
                                                        className="width-100cent margin-left-20 text-muted"
                                                    >
                                                        {this.props.bills == true || this.props.payments ? <><Grid.Column width={4}>
                                                            <label>{FILTER_TITLES.START_DATE}</label>
                                                            <DateData
                                                                name={`startDate`}
                                                                autoComplete="off"
                                                                popperClassName="dateTime"
                                                                dateFormat={DATE_FORMATS.dd_MM_yyyy}
                                                                placeholderText={PLACE_HOLDERS.from || "From"}
                                                                selected={values.startDate}
                                                                startDate={values.startDate}
                                                                endDate={values.endDate}
                                                                maxDate={values.endDate ? values.endDate : ''}
                                                                selectsStart
                                                                timeIntervals={5}
                                                                customInput={<FormUi.Input error={values.startDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                            />
                                                            {touched.startDate && errors.startDate ? <strong className="w3-text-red w3-tiny font-weight-300">{errors.startDate}</strong> : ''}
                                                        </Grid.Column> 
                                                        <Grid.Column width={4}>
                                                            <label>{FILTER_TITLES.END_DATE}</label>
                                                            <DateData
                                                                name={`endDate`}
                                                                autoComplete="off"
                                                                popperClassName="dateTime"
                                                                dateFormat={DATE_FORMATS.dd_MM_yyyy}
                                                                placeholderText={PLACE_HOLDERS.to || "To"}
                                                                selected={values.endDate}
                                                                endDate={values.endDate}
                                                                minDate={values.startDate ? values.startDate : ''}
                                                                timeIntervals={5}
                                                                customInput={<FormUi.Input error={values.endDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                            />
                                                            {touched.endDate && errors.endDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.endDate}</strong> : ''}
                                                        </Grid.Column>  </> : null}
                                                        {this.props.bills == true && <Grid.Column>
                                                            <label>{FILTER_TITLES.STATUS}</label>
                                                            <Dropdown
                                                                name={'billStatus'}
                                                                multiple
                                                                selection
                                                                style={{ width: "100%", fontWeight: "normal" }}
                                                                placeholder={"Please select Status"}
                                                                onChange={this.handleStatusChange}
                                                                options={
                                                                    [
                                                                        {
                                                                            key: "1",
                                                                            text: 'Pending',
                                                                            value: "Pending",
                                                                        },
                                                                        {
                                                                            key: "2",
                                                                            text: 'Approved',
                                                                            value: "Approved",
                                                                        },
                                                                        {
                                                                            key: "3",
                                                                            text: 'Rejected',
                                                                            value: "Rejected",
                                                                        },
                                                                        {
                                                                            key: "4",
                                                                            text: 'Partial Payment',
                                                                            value: "Partial Payment",
                                                                        },
                                                                        {
                                                                            key: "5",
                                                                            text: 'Completed',
                                                                            value: "Completed",
                                                                        },
                                                                    ]
                                                                }
                                                                value={this.state.statusSelected}
                                                            />
                                                        </Grid.Column>}
                                                       
                                                        {(this.props.bills == true)  || (this.props.PO) == true ? <><Grid.Column>
                                                            <label>{FILTER_TITLES.VENDOR}</label>
                                                            <Fieldmik component={PurchaseOrderVendorDropdown} name="vendorName" placeholder="Vendor Name" getVehicleData={this.getVehicleData} />
                                                        </Grid.Column>
                                                            <Grid.Column>
                                                                <label>{FILTER_TITLES.BRANCH}</label>
                                                                <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" branchId='branchId' /*getMasterBranchSelected={getMasterBranchSelected}*/ />
                                                            </Grid.Column></>: null}
                                                        {this.props.PO == true ?<><Grid.Column>
                                                            <label>{FILTER_TITLES.VEHICLE_NO}</label>
                                                            <Fieldmik component={VendorVehicleDropdown} name="vehicleNo" placeholder="Vehicle Number" vehicleData={this.state.vehicleData} vehicleId='vehicleId' />
                                                        </Grid.Column>
                                                        </>  : null}                                                      
                                                    </Grid>
                                                    <Grid >
                                                    <Button style={{marginLeft:'555px',marginBottom:'5px'}} type="submit" onClick={handleSubmit} basic size="medium"  color="blue"  icon>{'Submit'}</Button>
                                                   
                                                    </Grid> {/* <Button type="button" onClick={this.props.refreshDates} className="mr-4 w3-tiny" circular basic size="mini"  icon><Icon name="refresh" color="grey" /></Button> */}
                                                </>
                                            )}
                                        </Formik>
                                    </FormUi.Field>

                                </FormUi.Group >
                            </Segment>
                        </div>
                    </>

                : null}
                <ImportModal
                    openBox={this.state.ImportModalState}
                    handleClose={this.handleImportClose}
                    fileName={this.props.fileName}
                    baseURL={this.props.path}
                />

             
        
            {this.props.dataLoading ? <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment> :
                <div className="ag-theme-material agOver">
                    <AgGridReact
                        quickFilterText={this.state.searchValue}
                        domLayout="autoHeight"
                        modules={this.state.modules}
                        sideBar={this.state.sideBar}
                        rowGroupPanelShow={"always"}
                        suppressAutoSize={true}
                        columnDefs={this.props.columnDefs}
                        defaultColDef={this.state.defaultColDef}
                        frameworkComponents={this.state.frameworkComponents}
                        rowSelection="multiple"
                        noRowsOverlayComponent={this.state.noRowsOverlayComponent}
                        noRowsOverlayComponentParams={this.state.noRowsOverlayComponentParams}
                        rowData={this.props.rowData}
                        pagination={true}
                        baseURL={this.props.baseURL}
                        suppressRowClickSelection={this.props.suppressRowSelection}
                        paginationPageSize={10}
                        onGridReady={this.onGridReady}
                        exportBtn={this.exportDataGrid}
                        onFilterChanged={this.filterChanged}
                        onRowSelected={this.props.rowSelected}
                        {...this.props}
                    />
                </div>}
                
            </>
        )
    };
};

export default AgGridTable;
